import * as React from "react";
import { memo } from "react";
const SvgEditorBackground = (props) => /* @__PURE__ */ React.createElement("svg", { preserveAspectRatio: "none", width: 287, height: 64, viewBox: "0 0 287 64", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M-28.6923 10.0392L-36 64H278.962L287 0L-28.6923 10.0392Z", fill: "currentColor" }));
const Memo = memo(SvgEditorBackground);
export default Memo;
